export const TYPE_INCOMING = "incoming";
export const TYPE_QUESTION = "question";
export const TYPE_SYSTEM = "system";
export const TYPE_FREETEXT = "freetext_question"
export const TYPE_STATEMENT = "statement";
export const SYSTEM_CONSULTATION_CLOSED = "consultation_closed"
export const SYSTEM_TYPE_DONT_UNDERSTAND = "consultation_didnot_get_that";
export const SYSTEM_TYPE_ALLREADY_ANSWERED = "consultation_already_answered";